import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import * as S from './styles';

const msgs = defineMessages({
  skip: { id: 'accessibility_skip_button' },
});

const SkipToContent: React.FC = () => {
  const intl = useIntl();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const skipTarget = document.getElementById('skip-target');

    if (skipTarget) {
      e.preventDefault();
      skipTarget.focus();
    }
  };

  return (
    <S.SkipLink href="#main-content" onClick={handleClick}>
      {intl.formatMessage(msgs.skip)}
    </S.SkipLink>
  );
};

export default SkipToContent;
